export default __webpack_public_path__ + "static/media/quessimi.2bc9d3c7.png";